<template>
  <h3 style="margin-top: 40px; margin-bottom: 10px" class="label">
    <translate>{{ label }}</translate>
    <span v-if="asterisk">*</span>
    <slot></slot>
  </h3>
</template>

<script>
export default {
  name: 'fob-label',
  props: [ 'label', 'asterisk' ]
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/form/Label.vue